export default "__VITE_ASSET__fb447380__"